export default __webpack_public_path__ + "static/media/raccoon_6.31923a26.png";